import { ICartEntry } from '@rbi-ctg/menu';
import { routes } from 'utils/routing';

import { CartEntryType } from './types';

export const isCartEntryItem = (cartEntry: ICartEntry) => cartEntry.type === CartEntryType.item;

export const isCartEntryCombo = (cartEntry: ICartEntry) => cartEntry.type === CartEntryType.combo;

export const isCartEntryItemOption = (cartEntry: ICartEntry) =>
  cartEntry.type === CartEntryType.itemOption;

export const isCartEntryItemOptionModifier = (cartEntry: ICartEntry) =>
  cartEntry.type === CartEntryType.itemOptionModifier;

export const isCartEntryComboSlot = (cartEntry: ICartEntry) =>
  cartEntry.type === CartEntryType.comboSlot;

export const isCartEntryItemOrCombo = (cartEntry: ICartEntry) =>
  isCartEntryItem(cartEntry) || isCartEntryCombo(cartEntry);

export const isCartEntryPicker = (pathname: string) =>
  new RegExp(`^${routes.menu}/picker`).test(pathname);
